/**
 * @generated SignedSource<<424a4c42dfc0e0f548beced7445136c9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateGeneralTimeRegistrationSettingsInput = {
  id: string;
  allowDoneTasks?: boolean | null;
  allowProjects?: boolean | null;
  allowInternalTime?: boolean | null;
  allowBillableSplit?: boolean | null;
  allowRoles?: boolean | null;
  allowExceedingEstimate?: boolean | null;
  allowOutsideTaskDates?: boolean | null;
  allowOutsideProjectDates?: boolean | null;
  requireTaskAssignment?: boolean | null;
  requireNote?: boolean | null;
  strictMode?: boolean | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type UpdateGeneralTimeRegistrationSettingsMutation$variables = {
  input: UpdateGeneralTimeRegistrationSettingsInput;
};
export type UpdateGeneralTimeRegistrationSettingsMutation$data = {
  readonly updateGeneralTimeRegistrationSettings: {
    readonly timeRegistrationSettings: {
      readonly id: string;
      readonly allowDoneTasks: boolean | null;
      readonly allowProjects: boolean | null;
      readonly allowInternalTime: boolean | null;
      readonly allowBillableSplit: boolean | null;
      readonly allowRoles: boolean | null;
      readonly allowExceedingEstimate: boolean | null;
      readonly allowOutsideProjectDates: boolean | null;
      readonly allowOutsideTaskDates: boolean | null;
      readonly requireTaskAssignment: boolean | null;
      readonly requireNote: boolean | null;
      readonly strictMode: boolean | null;
    } | null;
  } | null;
};
export type UpdateGeneralTimeRegistrationSettingsMutation$rawResponse = {
  readonly updateGeneralTimeRegistrationSettings: {
    readonly timeRegistrationSettings: {
      readonly id: string;
      readonly allowDoneTasks: boolean | null;
      readonly allowProjects: boolean | null;
      readonly allowInternalTime: boolean | null;
      readonly allowBillableSplit: boolean | null;
      readonly allowRoles: boolean | null;
      readonly allowExceedingEstimate: boolean | null;
      readonly allowOutsideProjectDates: boolean | null;
      readonly allowOutsideTaskDates: boolean | null;
      readonly requireTaskAssignment: boolean | null;
      readonly requireNote: boolean | null;
      readonly strictMode: boolean | null;
    } | null;
  } | null;
};
export type UpdateGeneralTimeRegistrationSettingsMutation = {
  variables: UpdateGeneralTimeRegistrationSettingsMutation$variables;
  response: UpdateGeneralTimeRegistrationSettingsMutation$data;
  rawResponse: UpdateGeneralTimeRegistrationSettingsMutation$rawResponse;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateGeneralTimeRegistrationSettingsPayload",
    "kind": "LinkedField",
    "name": "updateGeneralTimeRegistrationSettings",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "TimeRegistrationSettingsType",
        "kind": "LinkedField",
        "name": "timeRegistrationSettings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "allowDoneTasks",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "allowProjects",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "allowInternalTime",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "allowBillableSplit",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "allowRoles",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "allowExceedingEstimate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "allowOutsideProjectDates",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "allowOutsideTaskDates",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "requireTaskAssignment",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "requireNote",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "strictMode",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateGeneralTimeRegistrationSettingsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateGeneralTimeRegistrationSettingsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e7a29558786217a3bf29037861587735",
    "id": null,
    "metadata": {},
    "name": "UpdateGeneralTimeRegistrationSettingsMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateGeneralTimeRegistrationSettingsMutation(\n  $input: UpdateGeneralTimeRegistrationSettingsInput!\n) {\n  updateGeneralTimeRegistrationSettings(input: $input) {\n    timeRegistrationSettings {\n      id\n      allowDoneTasks\n      allowProjects\n      allowInternalTime\n      allowBillableSplit\n      allowRoles\n      allowExceedingEstimate\n      allowOutsideProjectDates\n      allowOutsideTaskDates\n      requireTaskAssignment\n      requireNote\n      strictMode\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a176836ebb6601dd5ab625ac0e1583c8";

export default node;
